export interface Notice {
  tone: 'info' | 'error';
  text: string;
}

export interface NoticeBarProps {
  notice: Notice;
  onDismiss: () => void;
}

const TONE_CLASS: Record<Notice['tone'], string> = {
  info: 'border-blue-200 bg-blue-50 text-blue-900',
  error: 'border-amber-200 bg-amber-50 text-amber-900',
};

/**
 * A one-line message under the document.
 *
 * `role="status"` rather than `alert` for information: "Preparing your
 * download" is worth reading, not worth interrupting whatever a screen reader
 * was in the middle of saying. Errors keep `alert`.
 */
export function NoticeBar({ notice, onDismiss }: NoticeBarProps) {
  return (
    <div
      className={`burfy-docs-no-print flex items-center gap-3 border-t px-4 py-2 text-xs ${TONE_CLASS[notice.tone]}`}
      role={notice.tone === 'error' ? 'alert' : 'status'}
    >
      <span className="flex-1">{notice.text}</span>
      <button
        type="button"
        className="rounded px-2 py-1 hover:bg-black/5"
        onClick={onDismiss}
      >
        Dismiss
      </button>
    </div>
  );
}
